import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    "message": "",
    "showToast": false
};

export const toastSlice = createSlice({
    name: "toast",
    initialState,
    reducers: {
        showToastAction: (state, { payload }) => payload,
        hideToastAction: (state, { payload }) => payload,
    }
})

export const { showToastAction, hideToastAction } = toastSlice.actions

export default toastSlice.reducer